/** @jsxImportSource @emotion/react */
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as authSelectors from "../../../auth/authSelectors";
import { useSelector } from "react-redux";
import { Table } from "../../../../components/table-components/Table";
import { colors } from "../../../../components/colors";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableBody } from "../../../../components/table-components/TableBody";
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { StyledText } from "../../../../assets/typography/typography";
import { TableEllipsisDropdown } from "../../../../components/TableEllipsisDropdown";
import { DropdownItemLink } from "../../../common/DropdownItemLink";
import { routes } from "../../../../appRoutingHelpers";
import { useParams } from "react-router";
import { AdyenBalanceAccountListItem } from "../../models/adyen-balance-account";

type Props = {
  balanceAccounts: AdyenBalanceAccountListItem[];
};

export const AdyenAccountHolderBalanceAccountsTable = ({
  balanceAccounts,
}: Props) => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText>Description</TableCellHeaderText>
          <TableCellHeaderText>Currency</TableCellHeaderText>
          <TableCellHeaderText>Reference</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {balanceAccounts.map((balanceAccount, i) => {
          const href = routes.adyenAccountHolderBalanceAccountsInspect(
            organizationKeyName,
            id,
            balanceAccount.id
          );

          return (
            <TableRow key={i}>
              <TableCellLink href={href} className="pl-5">
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {balanceAccount.description || "-"}
                </StyledText>
              </TableCellLink>
              <TableCellLink href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {balanceAccount.currency || "-"}
                </StyledText>
              </TableCellLink>
              <TableCellLink href={href}>
                <StyledText
                  className="bodyTextRegular mb-0"
                  color={colors.textPrimary}
                >
                  {balanceAccount.reference || "-"}
                </StyledText>
              </TableCellLink>
              <TableEllipsisDropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: (
                        <DropdownItemLink
                          icon={
                            <FontAwesomeIcon
                              icon={solid("arrow-up-right-from-square")}
                            />
                          }
                          to={href}
                        >
                          See details
                        </DropdownItemLink>
                      ),
                    },
                  ],
                }}
              />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
